import { Link, usePage } from '@inertiajs/react';
import { useState } from 'react';
import { LuListCollapse } from 'react-icons/lu';
import { MdClose } from 'react-icons/md';

import logo from '../assets/yottanet_logo.svg';

const Layout = ({ children }) => {
  const { url, props } = usePage();
  const { current_user } = props
  const isAuthenticated = current_user !== null;
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  return (
    <>
      <header className='sticky top-0 z-50 bg-black flex justify-between items-center pb-2 px-4 md:px-16'>
        <Link href='/'>
          <img src={logo} alt='Logo' className='h-14 md:h-22' />
        </Link>
        {/* Desktop Navigation - Hidden on mobile, flex on medium screens and above */}
        <nav className='hidden md:flex items-center gap-4'>
          <ul className='flex space-x-4 justify-center'>
            <li>
              <Link
                href='/'
                className={`hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                  url === '/'
                    ? 'underline underline-offset-4 text-yellow-primary'
                    : 'text-white'
                }`}
              >
                Home
              </Link>
            </li>

            <li>
              <Link
                href='#service'
                className={`hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                  url === '/#service'
                    ? 'underline underline-offset-4 text-yellow-primary'
                    : 'text-white'
                }`}
              >
                Services
              </Link>
            </li>

            <li>
              <Link
                href='/products'
                className={`hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                  url === '/products'
                    ? 'underline underline-offset-4 text-yellow-primary'
                    : 'text-white'
                }`}
              >
                Products
              </Link>
            </li>

            <li>
              <Link
                href='#about'
                className={`hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                  url === '/#about'
                    ? 'underline underline-offset-4 text-yellow-primary'
                    : 'text-white'
                }`}
              >
                About us
              </Link>
            </li>

            <li>
              <Link
                href='#blog'
                className={`hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                  url === '/#blog'
                    ? 'underline underline-offset-4 text-yellow-primary'
                    : 'text-white'
                }`}
              >
                Blog
              </Link>
            </li>
            {isAuthenticated && (
              <li>
                <Link
                  href='/dashboard/orders'
                  className={`hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                    url === '/dashboard/orders'
                      ? 'underline underline-offset-4 text-yellow-primary'
                      : 'text-white'
                  }`}
                >
                  Orders
                </Link>
              </li>
            )}
          </ul>
          {isAuthenticated && (
            <Link
              href='/logout'
              method='delete'
              as='button'
              className='text-red-700 hover:bg-red-900 rounded-full hover:text-white font-body py-1 px-3 shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
            >
              Logout
            </Link>
          )}
          <Link
            href='#contact'
            className='block text-center bg-yellow-primary text-slate-900 py-2 px-4 rounded-2xl hover:bg-yellow-secondary transition duration-200 ease-in-out'
          >
            Contact Us
          </Link>
        </nav>

        <div
          className='md:hidden cursor-pointer text-yellow-primary text-3xl'
          onClick={toggleMobileNav}
        >
          <LuListCollapse />
        </div>
      </header>

      {/* Mobile Navigation Pop-up/Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-90 z-50 transform transition-transform duration-300 ease-in-out ${
          isMobileNavOpen ? 'translate-x-0' : 'translate-x-full'
        } md:hidden flex flex-col items-center justify-center`}
      >
        <button
          type='button'
          className='absolute top-4 right-4 text-white text-3xl'
          onClick={toggleMobileNav}
        >
          <MdClose />
        </button>

        <ul className='flex flex-col space-y-6 text-xl'>
          <li>
            <Link
              href='/'
              className={`text-white hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                url === '/'
                  ? 'underline underline-offset-4 text-yellow-primary'
                  : ''
              }`}
              onClick={toggleMobileNav}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              href='#service'
              className={`text-white hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                url === '/#service'
                  ? 'underline underline-offset-4 text-yellow-primary'
                  : ''
              }`}
              onClick={toggleMobileNav}
            >
              Services
            </Link>
          </li>
          <li>
            <Link
              href='/products'
              className={`text-white hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                url === '/products'
                  ? 'underline underline-offset-4 text-yellow-primary'
                  : ''
              }`}
              onClick={toggleMobileNav}
            >
              Products
            </Link>
          </li>
          <li>
            <Link
              href='#about'
              className={`text-white hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                url === '/#about'
                  ? 'underline underline-offset-4 text-yellow-primary'
                  : ''
              }`}
              onClick={toggleMobileNav}
            >
              About us
            </Link>
          </li>
          <li>
            <Link
              href='#blog'
              className={`text-white hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                url === '/#blog'
                  ? 'underline underline-offset-4 text-yellow-primary'
                  : ''
              }`}
              onClick={toggleMobileNav}
            >
              Blog
            </Link>
          </li>
          {isAuthenticated && (
            <>
              <li>
                <Link
                  href='/dashboard/orders'
                  className={`hover:text-gray-300 hover:underline underline-offset-4 font-medium transition duration-200 ease-in-out transform hover:scale-105 ${
                    url === '/dashboard/orders'
                      ? 'underline underline-offset-4 text-yellow-primary'
                      : 'text-white'
                  }`}
                >
                  Orders
                </Link>
              </li>
              <li>
                <Link
                  href='/logout'
                  method='delete'
                  as='button'
                  className='text-red-700 hover:bg-red-900 rounded-full hover:text-white font-body py-1 shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
                >
                  Logout
                </Link>
              </li>
            </>
          )}

          <Link
            href='#contact'
            className='block text-center bg-yellow-primary text-slate-900 py-2 px-4 rounded-2xl hover:bg-yellow-secondary transition duration-200 ease-in-out'
          >
            Contact Us
          </Link>
        </ul>
      </div>

      <main className='mt-4 px-4 md:px-16'>{children}</main>
    </>
  );
};

export default Layout;
